export const DASHBOARD_ORIENTATION_NOTICE_STORAGE_KEY =
  "authenticated-product-orientation:v1";

const DISMISSED_VALUE = "dismissed";

export function readDashboardOrientationNoticeDismissed() {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const value = window.localStorage.getItem(
      DASHBOARD_ORIENTATION_NOTICE_STORAGE_KEY
    );

    if (value === null) {
      return false;
    }

    if (value === DISMISSED_VALUE) {
      return true;
    }

    window.localStorage.removeItem(
      DASHBOARD_ORIENTATION_NOTICE_STORAGE_KEY
    );
  } catch (_error) {
    return false;
  }

  return false;
}

export function writeDashboardOrientationNoticeDismissed() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(
      DASHBOARD_ORIENTATION_NOTICE_STORAGE_KEY,
      DISMISSED_VALUE
    );
  } catch (_error) {
    // Best-effort persistence only.
  }
}
